<template>
  <div class="background">
    <login-history>
      <div slot="title">Recent Logins</div>
    </login-history>
  </div>
</template>

<script>
  import LoginHistory from 'Common/LoginHistory';

  export default {
    components: {
      LoginHistory,
    },
  };
</script>

<style scoped lang="scss">
  .spinner {
    margin: auto;
  }
  .background {
    @include background;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/RecentLogins.vue